import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  message,
  Button,
  Card,
  Input,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import withRouter from "../withRouter";

import { postApi } from "../components/Utility";
import { useTypewriter } from "../utils/useTypewriter"
import { Collapse } from "antd";
import {
  QuestionCircleOutlined,
  RocketOutlined,
  BarChartOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const { Panel } = Collapse;

const { Content } = Layout;
const { Title } = Typography;

const ThinkingLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "30px",
      }}
    >
      {/* Main circle with particles */}
      <div style={{ position: "relative", width: "120px", height: "120px" }}>
        {/* Center circle */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "30px",
            animation: "glow 2s ease-in-out infinite",
          }}
        >
          ✨
        </div>

        {/* Floating particles */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              //top: "50%",
              //left: "50%",
              width: "100%",
              height: "90%",
              transform: `rotate(${i * 45}deg)`,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "50%",
                width: "8px",
                height: "8px",
                marginLeft: "-4px",
                borderRadius: "50%",
                background: `hsl(${i * 45}, 70%, 60%)`,
                animation: `float 2s ease-in-out ${i * 0.25}s infinite`,
              }}
            />
          </div>
        ))}
      </div>

      {/* Text */}
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          background: "linear-gradient(90deg, #667eea, #764ba2)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animation: "pulse 2s ease-in-out infinite",
        }}
      >
        Trackeazy AI is thinking...
      </div>

      {/* Animated waves */}
      <div style={{ display: "flex", gap: "4px", height: "40px", alignItems: "flex-end" }}>
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            style={{
              width: "6px",
              backgroundColor: "#1890ff",
              borderRadius: "3px",
              animation: `wave 1s ease-in-out ${i * 0.1}s infinite`,
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { 
            transform: translateY(0) scale(1);
            opacity: 0.8;
          }
          50% { 
            transform: translateY(-15px) scale(1.2);
            opacity: 1;
          }
        }

        @keyframes glow {
          0%, 100% { 
            box-shadow: 0 0 20px rgba(102, 126, 234, 0.5);
          }
          50% { 
            box-shadow: 0 0 40px rgba(102, 126, 234, 0.8);
          }
        }

        @keyframes wave {
          0%, 100% { height: 10px; }
          50% { height: 35px; }
        }
      `}</style>
    </div>
  );
};



export const TypewriterText = ({ text, speed = 15 }) => {
  const { displayedText, isComplete } = useTypewriter(text, speed);

  const lines = displayedText.split("\n").filter((line) => line.trim() !== "");

  return (
    <div style={{ whiteSpace: "pre-line" }}>
      {lines.map((line, index) => {
        const trimmed = line.trim();

        if (index === 0 || index === 1 || trimmed === "Recommendations:") {
          return (
            <p key={index}>
              <strong style={{ fontSize: "16px" }}>{trimmed}</strong>
            </p>
          );
        }

        return <p key={index}>{trimmed}</p>;
      })}
    </div>
  );
};

class AiAssistant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      question: "",
      response: null,
      loading: false,
      data: "",
      selectedTemplate: '',
      module_name: ''
    };
  }
  async componentDidMount() { }

  handleAsk = async (isPredefinedQuestions) => {
    const { question } = this.state;

    // Validation
    if (!question.trim()) {
      message.warning("Please enter a question before asking.");
      return;
    }

    // Start loading
    this.setState({ loading: true, response: null, data: "" });

    try {
      var response = await postApi
        .getClient()
        .post("https://dolphin.trackeazy.com/query/", {
          // nl_query: encodeURIComponent(question),
          nl_query: this.state.question,
          userId: this.props.getUserData().userId,
          companyId: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          parentId: this.props.getUserData().userCompanyId,
          isPredefinedQuestions: isPredefinedQuestions,
          selectedTemplate: this.state.selectedTemplate,
          module_name: this.state.module_name
        });

      const contentType = response.headers["content-type"];
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Unexpected response format");
      }

      const summary = response.data.summary || "No data returned from server.";
      this.setState({ data: summary, loading: false });
    } catch (error) {
      console.log("API error:", error);

      message.error("Something went wrong. Please try again later.");
    } finally {
      this.setState({ loading: false });
    }
  };

  onInputChange = (e) => {
    console.log(e.target.value);
    this.setState({ question: e.target.value });
  };

  render() {
    const { question, response, loading, data } = this.state;

    const lines = data.split("\n").filter((line) => line.trim() !== "");

    // Predefined templates for the accordion
    const templateData = [
      {
        key: "1",
        header: " Vehicle Tracking & Live Monitoring",
        icon: <BarChartOutlined />,
        items: [
          {
            display: "How can I view all vehicles on the map, including in multiple windows? ",
            module_name: "RAG",
            json: {
            }
          },
          {
            display: "Where are my vehicles currently located? ",
            module_name: "LAST_DATA",
            json: {
              "status": [],
              "COLUMNS": [
                "vl.location",
                "vl.latitude",
                "vl.longitude"
              ],
              "COUNT": false,
              "LIMIT": 5,
              "RESULT_TYPE": "list",
              "FILTERS": []
            }
          },
          {
            display: "Which vehicles are currently in Dubai or Abu Dhabi ?",
            module_name: "LAST_DATA",
            json: {
              "status": [],
              "COLUMNS": [],
              "COUNT": false,
              "LIMIT": 5,
              "RESULT_TYPE": "list",
              "FILTERS": [
                {
                  "column": "vl.location",
                  "operator": "LIKE",
                  "value": "Dubai"
                },
                {
                  "column": "vl.location",
                  "operator": "LIKE",
                  "value": "Abu Dhabi"
                }
              ]
            }
          },
          {
            display: "How can I go to the live location of a particular vehicle ? ",
            module_name: "RAG",
            json: {
            }
          },
          {
            display: "Can I see live road traffic on the map ?",
            module_name: "RAG",
            json: {
            }
          },
          {
            display: "How can I find a vehicle using its plate number?",
            module_name: "RAG",
            json: {
            }
          },
        ],
      },
      {
        key: "2",
        header: "Vehicle Status & Utilization",
        icon: <ThunderboltOutlined />,
        items: [
          {
            display: "Which vehicles are moving, stopped, or idle right now? ",
            module_name: "LAST_DATA",
            json: {
              "status": ["running", "stopped", "idle"],
              "COLUMNS": [],
              "COUNT": false,
              "LIMIT": 5,
              "RESULT_TYPE": "list",
              "FILTERS": []
            }
          },
          {
            display: "Which vehicles are not reporting or are out of service?",
            module_name: "LAST_DATA",
            json: {
              "status": ["no_data"],
              "COLUMNS": [],
              "COUNT": false,
              "LIMIT": 5,
              "RESULT_TYPE": "list",
              "FILTERS": []
            }
          },
          {
            display: "How many hours has each vehicle been inactive?",
            module_name: "LAST_DATA",
            json: {
              'status': ['no_data'],
              'COLUMNS': ['nodata_Since'],
              'COUNT': false,
              'LIMIT': 5,
              'RESULT_TYPE': 'list',
              'FILTERS': []
            }
          },
          {
            display: " How many vehicles are currently moving, along with their plate numbers?",
            module_name: "LAST_DATA",
            json: {
              'status': ['running'],
              'COLUMNS': ['v.vehicleNo'],
              'COUNT': false,
              'LIMIT': 5,
              'RESULT_TYPE': 'count_details',
              'FILTERS': []
            }
          },
        ],
      },
      {
        key: "3",
        header: "Trip History & Playback ",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "How can I view a vehicle’s tracking history for a specific date?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I review a vehicle’s records from yesterday?",
            module_name: "RAG",
            json: {

            }
          }
        ],
      },
      {
        key: "4",
        header: "Reports & Analytics",
        icon: <QuestionCircleOutlined />,
        items: [
          {
            display: "Can I see a summary of today’s fleet activity? ",
            module_name: "DAY_SUMMARY",
            json: {
              'status': [],
              'COLUMNS': ['v.vehicleNo', 'd.distanceTravel', 'd.travelduration', 'd.idleduration', 'd.stopDuration', 'd.maxSpeed'],
              'COUNT': false,
              'LIMIT': 50,
              'AGGREGATE': '',
              'RESULT_TYPE': 'list',
              'FILTERS': [{ 'column': 'd.startTime', 'operator': '=', 'value': 'today' }]
            }
          },
          {
            display: "How can I view fleet performance and operational reports?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " Can I get a simplified vehicle report that’s easy to understand? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How many kilometers did each vehicle travel?",
            module_name: "DAY_SUMMARY",
            json: {
              'status': [],
              'COLUMNS': ['v.vehicleNo', 'd.distanceTravel'],
              'COUNT': false,
              'LIMIT': 50,
              'AGGREGATE': '',
              'RESULT_TYPE': 'list',
              'FILTERS': [{ 'column': 'd.startTime', 'operator': '=', 'value': 'today' }]
            }
          },
          {
            display: "Which vehicle traveled the most distance today? ",
            module_name: "DAY_SUMMARY",
            json: {
              'status': [],
              'COLUMNS': ['v.vehicleNo', 'd.distanceTravel'],
              'COUNT': false,
              'LIMIT': 1,
              'AGGREGATE': 'MAX',
              'RESULT_TYPE': 'single_query',
              'FILTERS': [{ 'column': 'd.startTime', 'operator': '=', 'value': 'today' }]
            }
          },
          {
            display: "Which vehicle reached the highest speed today? ",
            module_name: "DAY_SUMMARY",
            json: {
              'status': [],
              'COLUMNS': ['v.vehicleNo', 'd.maxSpeed'],
              'COUNT': false,
              'LIMIT': 1,
              'AGGREGATE': 'MAX',
              'RESULT_TYPE': 'single_query',
              'FILTERS': [{ 'column': 'd.startTime', 'operator': '=', 'value': 'today' }]
            }
          },
          {
            display: "How many vehicles were out of service?  ",
            module_name: "LAST_DATA",
            json: {
              'status': ['no_data'],
              'COLUMNS': [],
              'COUNT': true,
              'LIMIT': 5,
              'RESULT_TYPE': 'count',
              'FILTERS': []
            }
          },
        ],
      },
      {
        key: "5",
        header: "Alerts & Notifications",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "How can I set up a new alert?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I activate or deactivate alerts?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How do I adjust the app’s notification settings?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I activate all notifications for my vehicles?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "Did any vehicle exceed the speed limit? ",
            module_name: "ALERT_REPORT",
            json: {
              'status': [],
              'COLUMNS': ['rs.name'],
              'COUNT': false,
              'LIMIT': 50,
              'AGGREGATE': 'MAX',
              'RESULT_TYPE': 'list',
              'FILTERS': [{ 'column': 'rl.time', 'operator': '=', 'value': 'today' }, { 'column': 'rs.ruleSelectorId', 'operator': 'IN', 'value': '7' }]
            }
          },
          {
            display: "Which vehicles are involved in reckless driving?",
            module_name: "DAY_SUMMARY",
            json: {
              'status': [],
              'COLUMNS': ['v.vehicleNo', 'd.overspeedCount'],
              'COUNT': false,
              'LIMIT': 50,
              'AGGREGATE': '',
              'RESULT_TYPE': 'list',
              'FILTERS': [{ 'column': 'd.overspeedCount', 'operator': '>', 'value': 0 }, { 'column': 'd.startTime', 'operator': '=', 'value': 'today' }]
            }
          },
          {
            display: "How can I set an alert for vehicle maintenance or garage entry? ",
            module_name: "RAG",
            json: {

            }
          }
        ],
      },
      {
        key: "6",
        header: "Geofencing & Restricted Areas ",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "How can I create a geofence around a specific area?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "Can you show me all the geofences that have been created?",
            module_name: "GEOFENCE_ZONE",
            json: {
              'status': [],
              'COLUMNS': ['g.name'],
              'COUNT': false,
              'LIMIT': 200,
              'AGGREGATE': '',
              'RESULT_TYPE': 'list',
              'FILTERS': []
            }
          },
          {
            display: "How can I activate or deactivate geofence alerts? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I activate or deactivate geofence alerts? ",
            module_name: "RAG",
            json: {

            }
          },
        ],
      },
      {
        key: "7",
        header: "Maintenance & Vehicle Management",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "How can I add or update vehicle maintenance records?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " How can I check a vehicle’s expiry date? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How do I change a vehicle’s type or classification?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " How can I immobilize a vehicle?",
            module_name: "RAG",
            json: {

            }
          },
        ],
      },
      {
        key: "8",
        header: "Navigation & Route Optimization",
        icon: <FileTextOutlined />,
        items: [
          {
            display: " How can I share a vehicle’s live location?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " Can I send a vehicle’s location via WhatsApp? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I share vehicle reports via WhatsApp? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "What is the best route for my vehicle between two locations?",
            module_name: "RAG",
            json: {

            }
          }
        ],
      },
      {
        key: "9",
        header: "Application Settings ",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "How can I add or manage drivers in the system?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " How can I change the application language, for example to Arabic? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How do I adjust the page refresh time?",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: " How can I change my login password?",
            module_name: "RAG",
            json: {

            }
          }
        ],
      },
      {
        key: "10",
        header: "User Support & Training",
        icon: <FileTextOutlined />,
        items: [
          {
            display: "What features are available in this application? ",
            module_name: "RAG",
            json: {

            }
          },
          {
            display: "How can I contact the system supplier or support team? ",
            module_name: "RAG",
            json: {

            }
          }
        ],
      }
    ];

    const handleTemplateClick = async (item) => {
      await this.setState({
        question: item.display,
        selectedTemplate: item.json, // Store the JSON for use in API call
        module_name: item.module_name
      });
      this.handleAsk("1");
    };


    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">{this.context.translate("_AI_")}</div>
            </Col>
          </Row>
        </div>

        <Layout style={{ minHeight: "80vh", padding: "20px" }}>
          <Content>
            <Row gutter={24} style={{ height: "100%" }}>
              {/* Left side - Chat Interface (70%) */}
              <Col
                xs={24}
                lg={17}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Card
                  style={{
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    height: "calc(100vh - 120px)", // Full height minus header and padding
                    display: "flex",
                    padding: '20px',
                    flexDirection: "column",
                  }}
                  bodyStyle={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    padding: "24px",
                  }}
                >
                  <Title level={2} style={{ marginBottom: "16px" }}>
                    Ask your question
                  </Title>

                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginBottom: "24px",
                      alignItems: "center",
                    }}
                  >
                    <Input
                      placeholder="Type your question here..."
                      value={question}
                      onChange={this.onInputChange}
                      onPressEnter={() => this.handleAsk("0")}
                      size="large"
                    />
                    <Button
                      type="primary"
                      onClick={() => this.handleAsk("0")}
                      loading={loading}
                      size="large"
                    >
                      Ask
                    </Button>
                  </div>

                  {/* Scrollable response area */}
                  <div
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      padding: "16px",
                      backgroundColor: "#fafafa",
                      borderRadius: "6px",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    {data ? (
                      <TypewriterText text={data} speed={15} />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          color: "#999",
                          fontSize: "14px",
                        }}
                      >
                        {loading ? <ThinkingLoader /> : "Your AI response will appear here..."}
                      </div>
                    )}
                  </div>
                </Card>
              </Col>

              {/* Right side - Accordion (30%) */}
              <Col xs={24} lg={7}>
                <Card
                  style={{
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    padding: '20px',
                    borderRadius: "8px",
                  }}
                >
                  <Title level={4} style={{ marginBottom: "16px" }}>
                    <RocketOutlined /> FAQ
                  </Title>
                  <Collapse
                    accordion
                    bordered={false}
                    expandIconPosition="end"
                    style={{
                      background: "transparent",
                    }}
                  >
                    {templateData.map((category) => (
                      <Panel
                        header={
                          <span>
                            {category.icon}{" "}
                            <strong style={{ marginLeft: "8px" }}>
                              {category.header}
                            </strong>
                          </span>
                        }
                        key={category.key}
                        style={{
                          marginBottom: "12px",
                          borderRadius: "6px",
                          border: "1px solid #f0f0f0",
                          overflow: "hidden",
                        }}
                      >
                        <div style={{ paddingLeft: "8px" }}>
                          {category.items.map((item, idx) => (
                            <div
                              key={idx}
                              onClick={() => handleTemplateClick(item)}
                              style={{
                                padding: "10px 12px",
                                cursor: "pointer",
                                borderRadius: "4px",
                                marginBottom: "6px",
                                backgroundColor: "#fafafa",
                                transition: "all 0.2s",
                                fontSize: "13px",
                                border: "1px solid transparent",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e6f7ff";
                                e.currentTarget.style.borderColor = "#1890ff";
                                e.currentTarget.style.transform = "translateX(4px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#fafafa";
                                e.currentTarget.style.borderColor = "transparent";
                                e.currentTarget.style.transform = "translateX(0)";
                              }}
                            >
                              • {item.display}
                            </div>
                          ))}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>

                  <div
                    style={{
                      marginTop: "20px",
                      padding: "12px",
                      backgroundColor: "#f6f8fa",
                      borderRadius: "6px",
                      fontSize: "12px",
                      color: "#666",
                    }}
                  >
                    <SettingOutlined style={{ marginRight: "6px" }} />
                    Click any template to auto-fill your question
                  </div>
                </Card>
              </Col>
            </Row>
          </Content>
        </Layout>

        <div
          style={{ textAlign: "center", marginTop: "10px", fontSize: "10px" }}
        >
          This is a beta version. Features are still evolving and may not be
          final. We welcome suggestions and feedback during this phase.
        </div>
      </>
    );
  }
}
AiAssistant.contextType = StoreContext;
export default observer(withRouter(AiAssistant));
